<div class="dialog-header">
    <h2 mat-dialog-title class="lmc-dialog-title dialog-title-icon">
        <mat-icon color="warn">warning</mat-icon>
        Remove co-applicant
    </h2>
    <button mat-icon-button mat-dialog-close type="button"
            class="close-button" aria-label="Close without removing" matTooltip="Close">
        <mat-icon>close</mat-icon>
    </button>
</div>

<mat-dialog-content>
    <p>Removing the co-applicant will also affect any details associated with them:</p>
    <ul class="affected-list">
        <li>The co-applicant will be removed from application.</li>
        <li>TransUnion credit report will be archived.</li>
    </ul>

    <mat-form-field appearance="outline" class="reason-field">
        <mat-label>Reason for removal</mat-label>
        <textarea matInput [formControl]="reason" rows="2" [maxlength]="reasonMaxLength" cdkFocusInitial></textarea>
        <mat-hint align="end">{{ reason.value.length }} / {{ reasonMaxLength }}</mat-hint>
        <mat-error *ngIf="reason.hasError('required')">A reason is required</mat-error>
    </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-stroked-button type="button" mat-dialog-close>Cancel</button>
    <button mat-raised-button color="warn" type="button" [disabled]="reason.invalid" (click)="onRemove()">Remove</button>
</mat-dialog-actions>
